import {PriorityIcon} from '@priority-software/priority-style-react';

export enum TileIcon {
    F = PriorityIcon.bulletsList,
    P = PriorityIcon.dNew,
    E = PriorityIcon.dNew,
    G = PriorityIcon.dNew,
    R = PriorityIcon.iconTypeR1,
    O = PriorityIcon.graph,
    B = PriorityIcon.dashboard,
    D = PriorityIcon.dashboard,
    H = PriorityIcon.newReport
}

export enum TileIconType {
    F = 'F',
    E = 'E',
    G = 'G',
    P = 'P',
    R = 'R',
    O = 'O',
    B = 'B',
    H = 'H',
    D = 'D'
}
